import { parseSparklinkFromDestinationUrl } from '@arthelper/shared/sparklink';

// Only the query decides: stored sparklinks point at town-square, and the host is ignored.
// A link opens Arty when it has something to say or a spark to run.
export function isSparklink(url: string | null | undefined): url is string {
  if (!url) {
    return false;
  }
  const parsed = parseSparklinkFromDestinationUrl(url)?.parsed;
  return !!(parsed?.sparkId || parsed?.message);
}
